/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is µg/mL the same as ng/µL?`)
};

const es_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es µg/mL lo mismo que ng/µL?`)
};

const de_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist µg/mL dasselbe wie ng/µL?`)
};

const nl_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is µg/mL hetzelfde als ng/µL?`)
};

const fr_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mL est-il identique à ng/µL ?`)
};

const it_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mL è uguale a ng/µL?`)
};

const pt_br2_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mL é o mesmo que ng/µL?`)
};

const pt_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mL é o mesmo que ng/µL?`)
};

const ja_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mLとng/µLは同じですか？`)
};

const zh_od_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`µg/mL 与 ng/µL 相同吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_q4", locale)
	if (locale === "en") return en_od_faq_q4(inputs)
	if (locale === "es") return es_od_faq_q4(inputs)
	if (locale === "de") return de_od_faq_q4(inputs)
	if (locale === "nl") return nl_od_faq_q4(inputs)
	if (locale === "fr") return fr_od_faq_q4(inputs)
	if (locale === "it") return it_od_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_q4(inputs)
	if (locale === "pt") return pt_od_faq_q4(inputs)
	if (locale === "ja") return ja_od_faq_q4(inputs)
	return zh_od_faq_q4(inputs)
};